import api from '../config/api';

/**
 * Get all application modules
 * @returns {Promise} Array of application modules
 */
export const getApplications = async () => {
    try {
        const response = await api.get('/api/core/applications');
        return response.data;
    } catch (error) {
        console.error('Error fetching applications:', error);
        throw error;
    }
};

/**
 * Get specific application by ID
 * @param {number} id - Application ID
 * @returns {Promise} Application object
 */
export const getApplicationById = async (id) => {
    try {
        const response = await api.get(`/api/core/applications/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching application ${id}:`, error);
        throw error;
    }
};

/**
 * Get configuration for an application
 * @param {number} applicationId - Application ID
 * @param {string} key - Optional configuration key
 * @returns {Promise} Configuration array
 */
export const getConfiguration = async (applicationId, key = null) => {
    try {
        const params = key ? { key } : {};
        const response = await api.get(`/api/core/config/${applicationId}`, { params });
        return response.data;
    } catch (error) {
        console.error(`Error fetching configuration for app ${applicationId}:`, error);
        throw error;
    }
};

/**
 * Check if an application is enabled (exists and signed up)
 * @param {number} applicationId - Application ID
 * @returns {Promise<boolean>} True if application is enabled
 */
export const isApplicationEnabled = async (applicationId) => {
    try {
        const app = await getApplicationById(applicationId);
        return app && (app.SignedUp === true || app.SignedUp === 1);
    } catch (error) {
        // If not found or error, consider it disabled
        return false;
    }
};

/**
 * Check if customer activation is enabled
 * @param {number} applicationId - Application ID
 * @returns {Promise<boolean>} True if customer activation is enabled
 */
export const isCustomerActivationEnabled = async (applicationId) => {
    try {
        const response = await api.get(`/api/core/config/${applicationId}/customer-activation`);
        return response.data.enabled === true;
    } catch (error) {
        console.error('Error checking customer activation:', error);
        return false;
    }
};

